import React, { useState } from "react";
import { Box, Text, Switch } from "@chakra-ui/react";
import { PageCanvas } from "../../layouts/PageCanvas";
import { PageContainer } from "../../layouts/PageContainer";
import { PageHeader } from "../../layouts/PageHeader";
import ExternalSearchQuery from "./ExternalSearchQuery";

const ExternalSearchPage = () => {
  const [includeInternalData, setIncludeInternalData] = useState(false);

  const toggleIncludeInternalData = () => {
    setIncludeInternalData((prev) => !prev);
  };

  return (
    <PageContainer>
      <PageHeader title="External Search" isIncludeProfile={true} color="#1C4342">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >

          <Box display="flex" alignItems="center">
            <Text mr={2} fontSize="lg">
              Include Internal Data in Search (demo mode)
            </Text>
            <Switch
              colorScheme="teal"
              size="lg"
              isChecked={includeInternalData}
              onChange={toggleIncludeInternalData}
            />
          </Box>
        </Box>
      </PageHeader>
      <PageCanvas overflow="auto">
        <Box px={"4"} py={8}>
          <ExternalSearchQuery />
        </Box>
      </PageCanvas>
    </PageContainer>
  );
};

export default ExternalSearchPage;
